'use strict';

export default {
  userList: {
    columns: {
      name: 'Nom',
      email: 'Courriel',
      actions: 'Actions',
      status: 'Statut',
    },
    status: {
      pending: 'En attente',
      active: 'Actif',
    },
    buttons: {
      add: 'Ajouter',
    },
    addModal: {
      addAdministrator: 'Ajouter un administrateur',
      email: 'Courriel',
    },
  },
};
